import(/* webpackMode: "eager" */ "/app/src/app/[locale]/cookies-policy/page.tsx");
